// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__pM5pr","button_light":"Button_button_light__1HJf-","button_active":"Button_button_active__Nyh-I"};